import { css } from 'lit';

export default css`
  :host {
    --private-content-padding: 32px 24px 48px;
  }

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: var(--private-content-padding);
    gap: 32px;
  }

  .user-info-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 5px;
    width: 100%;
  }

  .user-info {
    flex-basis: 40%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
  }

  amityeko-icon {
    margin-top: -30px;
  }

  .date {
    color: var(--amityeko-color-gray-5);
  }
`;
